export enum TipoPergunta {
  Alternativa = 'Alternativa',
}
